import React, { useEffect, useState } from "react"
import { Link, useHistory, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import GoogleMapReact from 'google-map-react';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
import { toast } from 'react-toastify';


import { useForm, Controller } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { validationSchema } from './validation'

import { GET, POST, PUT, FILE, DELETE } from 'helpers/api'

import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Leaflet marker ikonkasi to‘g‘rilash
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
	iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
	iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
	shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});





function CreateUpdate() {
	const { t } = useTranslation();
	const { id, ownerLogin } = useParams();
	const history = useHistory();
	const [showPaymentModal, setShowPaymentModal] = useState(false);
	const [feeTypes, setFeeTypes] = useState([]);
	const [payments, setPayments] = useState([]);
	const [tariffCheck, setTariffCheck] = useState(null); // { sufficient, adjustment, newBalance, amountNeeded }
	const originalTariffId = React.useRef(null);



	const { register, handleSubmit, formState, control, setValue, getValues, watch } = useForm({
		mode: "onChange",
		resolver: yupResolver(validationSchema),
		defaultValues: {
			phone: "",
			regionId: 10,
			cityId: null,
			gpsPointX: 41.311081,
			gpsPointY: 69.240562,
			imageUrl: "",
			posTypeList: [],
			cashierList: [],
			merchandiserList: [],
			saleMinus: false,
			defaultCurrency: 1,
			tariffId: 1,
			hidePriceIn: true,
			loyaltyApi: "",
			balance: "",
			tariff: "",
			ownerLogin: '',
			ofd: false,
			activated: false,
			isMessagingEnabled: false,
			messagingCounter: 0,
			tgBot: false,
			TgBot: false,
			tgBotToken: "",
		}
	});
	const isMessagingEnabled = watch('isMessagingEnabled');
	const isTgBotEnabled = !!watch('tgBot') || !!watch('TgBot');
	const [isConnectingTelegramToken, setIsConnectingTelegramToken] = useState(false);
	const { errors } = formState
	const cityId = watch('cityId')

	const currencies = [{ "id": 1, "name": "So`m" }, { "id": 2, "name": "USD" }]
	const tariffs = [
		{ "id": 1, "name": "START", "value": 100000 },
		{ "id": 2, "name": "STANDART", "value": 150000 },
		{ "id": 3, "name": "PREMIUM", "value": 250000 }
	]

	async function handleTariffChange(option) {
		setValue('tariffId', option.id)
		setValue('tariff', option.value)
		setTariffCheck(null)

		const posId = getValues('id')
		if (!posId || option.id === originalTariffId.current) return

		const isUpgrade = option.id > originalTariffId.current
		if (!isUpgrade) return // downgrade always allowed, no need to check

		const result = await GET(`/services/admin/api/pos/${posId}/tariff-check?newTariffId=${option.id}`)
		if (result) setTariffCheck(result)
	}

	const [method, setMethod] = useState('create')
	const [regions] = useState([{ "id": 1, "name": "Андижанская область" }, { "id": 2, "name": "Бухарская область" }, { "id": 3, "name": "Джизакская область" }, { "id": 4, "name": "Кашкадарьинская область" }, { "id": 5, "name": "Навоийская область" }, { "id": 6, "name": "Наманганская область" }, { "id": 7, "name": "Самаркандская область" }, { "id": 8, "name": "Сурхандарьинская область" }, { "id": 9, "name": "Сырдарьинская область" }, { "id": 10, "name": "город Ташкент" }, { "id": 11, "name": "Ташкентская область" }, { "id": 12, "name": "Ферганская область" }, { "id": 13, "name": "Хорезмская область" }, { "id": 14, "name": "Респ. Каракалпакстан" }])
	const [cities, setCities] = useState([])
	const [posTypeList, setPosTypeList] = useState([])
	const [cashierList, setCashierList] = useState([])
	//const [merchandiserList, setMerchandiserList] = useState([])
	const [data, setData] = useState({
		gpsPointX: 41.311081,
		gpsPointY: 69.240562,
		imageUrl: '',
	})

	function selectLocation(t) {
		setData({ ...data, gpsPointX: t.lat, gpsPointY: t.lng })
	}

	async function fileUpload(e) {
		let formData = new FormData();
		formData.append("image", e.target.files[0]);

		const response = await FILE('/services/admin/api/upload/image', formData);
		setValue('imageUrl', response.url)
		setData({ ...data, 'imageUrl': response.url })
	}

	async function createUpdate(validatedData) {
		var sendData = { ...getValues(), ...validatedData }
		const tgBotEnabled = !!getValues('tgBot') || !!getValues('TgBot');
		sendData.tgBot = tgBotEnabled;
		sendData.TgBot = tgBotEnabled;
		sendData.tgBotToken = (getValues('tgBotToken') || '').trim();
		sendData.gpsPointX = data.gpsPointX
		sendData.gpsPointY = data.gpsPointY
		if (ownerLogin) {
			sendData.ownerLogin = ownerLogin
		}
		// ensure number type
		if (sendData.messagingCounter != null) {
			sendData.messagingCounter = Number(sendData.messagingCounter) || 0;
		}

		var response;
		if (sendData.id) {
			response = await PUT('/services/admin/api/pos', sendData, { loader: true })
			if (response) {
				history.push('/pos')
			}
		} else {
			response = await POST('/services/admin/api/pos', sendData, { loader: true })
			if (response) {
				history.push('/admin/clients')
			}
		}
	}

	async function connectTelegramToken() {
		const token = (getValues('tgBotToken') || '').trim();
		if (!token) {
			toast.warning("Telegram Bot token kiriting");
			return;
		}

		const posId = getValues('id');

		try {
			setIsConnectingTelegramToken(true);
			const response = await PUT('/services/admin/api/pos-tg-bot-token', { tgBotToken: token, pos_id: posId });
			if (response) {
				toast.success("Token yuborildi");
			}
		} catch (error) {
			toast.error("Token yuborishda xatolik");
		} finally {
			setIsConnectingTelegramToken(false);
		}
	}

	async function selectRegion(option) {
		setValue('regionId', option ? option.id : null);
		setValue('cityId', null);
		if (!option || !option.id) {
			setCities([]);
			return;
		}
		const response = await GET('/services/admin/api/city-helper/' + option.id);
		if (response && response.length > 0) {
			setCities(response);
		} else {
			setCities([]);
		}
	}


	async function getData() {
		if (!id) return;

		try {
			// 1) Load POS
			const pos = await GET(`/services/admin/api/pos/${id}`);
			if (!pos) return;

			// 2) Fill form
			Object.entries(pos).forEach(([key, value]) => setValue(key, value));
			originalTariffId.current = pos.tariffId;

			// If tgBotToken is present, enable the toggle and populate the input
			if (pos.tgBotToken) {
				setValue('tgBot', true);
				setValue('TgBot', true);
				setValue('tgBotToken', pos.tgBotToken);
			}

			// 3) Map preview data (use functional update to avoid stale closure)
			setData(d => ({
				...d,
				imageUrl: pos.imageUrl || '',
				gpsPointX: typeof pos.gpsPointX === 'number' ? pos.gpsPointX : d.gpsPointX,
				gpsPointY: typeof pos.gpsPointY === 'number' ? pos.gpsPointY : d.gpsPointY,
			}));

			// 4) Load cities only if regionId is present
			if (pos.regionId) {
				const temporaryCities = await GET(`/services/admin/api/city-helper/${pos.regionId}`);
				setCities(Array.isArray(temporaryCities) ? temporaryCities : []);
			} else {
				setCities([]);
				setValue('cityId', null);
			}

			// 5) Fetch payments & cashier list in parallel
			const [responsePayments, temporaryCashierList] = await Promise.all([
				GET(`/services/admin/api/pos-fees/payments/${id}`),
				GET(`/services/admin/api/cashier-helper/${id}`)
			]);
			setPayments(responsePayments || []);
			setCashierList(temporaryCashierList || []);

		} catch (e) {
			console.error('getData error:', e);
		}
	}


	async function getcashierList() {
		console.log(id);

		const response = await GET('/services/admin/api/cashier-helper/' + id)
		setCashierList(response)
	}

	async function getposTypeList() {
		const response = await GET('/services/admin/api/pos-type-helper')
		setPosTypeList(response)
	}

	async function getCities() {
		const regionId = getValues('regionId');
		if (!regionId) {
			setCities([]); // clear previous list if any
			return;
		}

		const response = await GET('/services/admin/api/city-helper/' + regionId);
		if (response && response.length > 0) {
			setCities(response);
		} else {
			setCities([]);
		}
	}


	function openPaymentModal() {
		setShowPaymentModal(true);
	}

	function closePaymentModal() {
		setShowPaymentModal(false);
	}

	function formatDate(date) {
		return date ? format(date, 'yyyy-MM-dd') : null;
	}

	async function addPayment(data) {
		const posId = getValues('id');
		if (!posId) return alert("POS ID is missing");

		const payload = {
			posId,
			feeId: parseInt(data.feeId),
			startDate: formatDate(data.startDate),
			endDate: formatDate(data.endDate),
			paymentDate: formatDate(data.paymentDate),
			amount: parseFloat(data.amount)
		};

		const res = await POST('/services/admin/api/pos-fees/make-payment', payload);
		if (res) {
			closePaymentModal();
			await fetchPayments(posId);
		}
	}

	async function fetchPayments(posId) {
		if (!posId) return;
		const response = await GET(`/services/admin/api/pos-fees/payments/${posId}`);
		setPayments(response || []);
	}

	async function fetchFeeTypes() {
		const response = await GET('/services/admin/api/pos-fees/types');
		setFeeTypes(response || []);
	}

	useEffect(() => {
		if (id) {
			setMethod('update');
			getData().then(() => fetchPayments(id));
		}
		fetchFeeTypes();
	}, []);

	useEffect(() => {
		if (id) {
			setMethod('update')
			getData()
		} else {
			getcashierList()
			//getmerchandiserList()
			getposTypeList()
			getCities()
		}
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	function deleteItem(deleteId) {
		DELETE('/services/admin/api/pos-fees/make-payment?id=' + deleteId).then(() => {
			getData();
		});
	}

	const Marker = () => (
		<div>
			<div className='pin'></div>
			<div className='pulse'></div>
		</div>
	);


	return (
		<>
			<div className="page-header d-flex mb-2">
				<div className="d-flex">
					<h4 className="vertical-center">
						{t('POS')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						<h6>{t('EDIT')}</h6>
					</div>
				</div>
			</div>
			<style>
				{`
					.leaflet-container {
						height: 250px !important;
						width: 100% !important;
						z-index: 0 !important;
					}
				`}
			</style>


			<div className="card">
				<div className="card-body">
					<form onSubmit={handleSubmit(createUpdate)} autoComplete="off">
						<div className="row mb-5">
							<div className="col-md-2">
								<div className="con-upload">
									<div className="con-img-upload">
										{data.imageUrl &&
											<div className="img-upload">
												<button type="button" className="btn-x-file" onClick={() => setData({ ...data, 'imageUrl': '' })}>
													<i className="uil-times"></i>
												</button>
												<img src={process.env.REACT_APP_PROD_SERVER_URL + data.imageUrl}
													style={{ maxWidth: 'none', maxHeight: '100%' }} alt="react" />
											</div>
										}
										{!data.imageUrl &&
											<div className="con-input-upload">
												<input type="file" onChange={(e) => fileUpload(e)} />
												<span className="text-input fz14">
													{t('IMAGE2')}
												</span>
											</div>
										}
									</div>
								</div>
							</div>
							<div className="col-md-3">
								<div className="form-group">
									<label>{t('SALE_POINT_NAME')}<span className="required-mark">*</span></label>
									<input type="text" className="form-control" name="name" {...register('name')} />
									<span className="text-danger text-sm">{errors.name?.message}</span>
								</div>
								<div className="form-group">
									<label>{t('TIN')}</label>
									<input type="number" className="form-control" name="tin" {...register('tin')} />
									<span className="text-danger text-sm">{errors.tin?.message}</span>
								</div>
								<div className="form-group">
									<label>{t('PHONE')}<span className="required-mark">*</span></label>
									<input type="number" className="form-control" name="phone" {...register('phone')}
									/>
									<span className="text-danger text-sm">{errors.phone?.message}</span>
								</div>
							</div>
							<div className="col-md-3">
								<div style={{ height: '250px', width: '100%' }}>
									<MapContainer
										center={[data.gpsPointX, data.gpsPointY]}
										zoom={14}
										style={{ height: '100%', width: '100%' }}
										scrollWheelZoom={false}
										dragging={false}
										zoomControl={false}
										doubleClickZoom={false}
										boxZoom={false}
										touchZoom={false}
									>
										<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
										{data.gpsPointX && data.gpsPointY && (
											<Marker
												key={`${data.gpsPointX}-${data.gpsPointY}`}
												position={[data.gpsPointX, data.gpsPointY]}
											/>
										)}
									</MapContainer>
								</div>




							</div>
							<div className="col-md-4">
								<div className="form-group">
									<label>{t('ADDRESS')}</label>
									<input type="text" className="form-control" name="address" {...register('address')} />
									<span className="text-danger text-sm">{errors.address?.message}</span>
								</div>
								<div className="form-group">
									<label>{t('REGION')}<span className="required-mark">*</span></label>
									<Controller
										name="regionId"
										control={control}
										render={({ field }) =>
											<Select
												{...field}
												options={regions}
												value={regions.find(option => option.id === getValues('regionId')) || ''}
												onChange={(option => selectRegion(option))}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>}
									/>
									<span className="text-danger text-sm">{errors.regionId}</span>
								</div>
								<div className="form-group">
									<label>{t('CITY')}<span className="required-mark">*</span></label>
									<Controller
										name="cityId"
										control={control}
										render={({ field }) =>
											<Select
												{...field}
												options={cities}
												value={cities.find(option => option.id === getValues('cityId')) || ''}
												onChange={(e) => setValue('cityId', e.id, { shouldValidate: true, shouldDirty: true })}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>}
									/>
								</div>
								<span className="text-danger text-sm">{errors.cityId}</span>
							</div>
						</div>

						<div className="row">
							<div className="col-md-6">
								<div className="form-group">
									<h5 className="fw-600">{t('ADDITIONALLY')}</h5>
									<hr />
								</div>
								<div className="row">
									<div className="col-md-12">
										{method === "create" &&
											<div className="form-group">
												<label>{t('ACTIVITIES')}</label>
												<Controller
													name="posTypeList"
													control={control}
													render={({ field }) =>
														<Select
															{...field}
															options={posTypeList}
															isMulti
															menuPosition='fixed'
															placeholder=""
															noOptionsMessage={() => t('LIST_IS_EMPTY')}
															getOptionLabel={(option) => option.name}
															getOptionValue={(option) => option.id}
														/>}
												/>
											</div>
										}
										{/* <div className="form-group">
											<label>{t('MERCHANDISER')}</label>
											<Controller
												name="merchandiserList"
												control={control}
												render={({ field }) =>
													<Select
														{...field}
														options={merchandiserList}
														isMulti
														placeholder=""
														noOptionsMessage={() => t('LIST_IS_EMPTY')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>}
											/>
										</div> */}
										<div className="form-group">
											<label>{t('CASHIERS')}</label>
											<Controller
												name="cashierList"
												control={control}
												render={({ field }) =>
													<Select
														{...field}
														options={cashierList}
														isMulti
														placeholder=""
														noOptionsMessage={() => t('LIST_IS_EMPTY')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>}
											/>
										</div>
									</div>
								</div>

								<div className="form-group mt-5">
									<h5 className="fw-600">{t('Integratsiya')}</h5>
									<hr />
								</div>

								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('ARCA')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="hidePriceIn" {...register('arca')} />
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2 mt-5">
									<p className="fw-600 vertical-center">{t('Multikassa')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="hidePriceIn" {...register('multikassa')} />
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2 mt-5">
									<p className="fw-600 vertical-center">{t('Telegram Bot')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="hidePriceIn" {...register('tgBot')} />
									</div>
								</div>
								{isTgBotEnabled && (
									<div className="mb-2">
										<p className="mb-2 text-muted">
											Telegram Bot Tokenni{" "}
											<a href="tg://resolve?domain=BotFather">
												BotFather
											</a>{" "}
											dan olib kiriting.
										</p>
										<div className="d-flex">
											<input
												type="text"
												className="form-control me-2"
												placeholder="Tokenni kiriting"
												{...register('tgBotToken')}
											/>
											<button
												type="button"
												className="btn btn-outline-primary text-nowrap"
												onClick={connectTelegramToken}
												disabled={isConnectingTelegramToken}
											>
												{isConnectingTelegramToken ? 'Ulanmoqda...' : 'Tokenni ulash'}
											</button>
										</div>
									</div>
								)}
							</div>
							<div className="col-md-6">
								<div className="form-group">
									<h5 className="fw-600">{t('SETTINGS')}</h5>
									<hr />
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('CURRENCY')}</p>
									<div className="col-md-4 p-0">
										<Controller
											name="defaultCurrency"
											control={control}
											render={({ field }) =>
												<Select
													{...field}
													options={currencies}
													value={currencies.find(option => option.id === getValues('defaultCurrency'))}
													onChange={(e) => setValue('defaultCurrency', e.id)}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>}
										/>
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('NEGATIVE_SALE')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="saleMinus" {...register('saleMinus')} />
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('HIDE_ADMISSION_PRICE')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="hidePriceIn" {...register('hidePriceIn')} />
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('LOYALTY')}</p>
									<div className="col-md-4 p-0">
										<input type="text" className="form-control" name="loyaltyApi" {...register('loyaltyApi')} />
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('ACTIVATED')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="activated" {...register('activated')} />
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">VIP</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="vipClient" {...register('vipClient')} />
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('TARIFF')}</p>
									<div className="col-md-4 p-0">
										<Controller
											name="tariffId"
											control={control}
											render={({ field }) =>
												<Select
													{...field}
													options={tariffs}
													value={tariffs.find(option => option.id === getValues('tariffId'))}
													onChange={handleTariffChange}
													placeholder=""
													noOptionsMessage={() => t('LIST_IS_EMPTY')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>}
										/>
										{tariffCheck && !tariffCheck.sufficient && (
											<div className="alert alert-danger mt-2 p-2" style={{ fontSize: '0.85rem' }}>
												<strong>{t('INSUFFICIENT_BALANCE')}</strong><br />
												{t('TARIFF_UPGRADE_NEED')}: <strong>{tariffCheck.amountNeeded.toLocaleString()}</strong><br />
												{t('CURRENT_BALANCE')}: <strong>{Math.round(getValues('balance') || 0).toLocaleString()}</strong>
											</div>
										)}
									</div>
								</div>

								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('TARIFF_AMOUNT')}</p>
									<div className="col-md-4 p-0">
										<input type="text" className="form-control" name="tariff" {...register('tariff')} />
									</div>
								</div>
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('BALANCE')}</p>
									<div className="col-md-4 p-0">
										<input type="text" className="form-control" name="balance" {...register('balance')} />
									</div>
								</div>

								{/* Messaging: enable/disable */}
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('MESSAGING_ENABLED')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input
											type="checkbox"
											className="form-check-input"
											{...register('isMessagingEnabled')}
											checked={!!watch('isMessagingEnabled') || !!watch('messagingEnabled')}
											onChange={(e) => {
												setValue('isMessagingEnabled', e.target.checked);
												setValue('messagingEnabled', e.target.checked);
											}}
										/>
									</div>
								</div>


								{/* Messaging counter */}
								<div className="d-flex justify-content-between mb-2">
									<p className="fw-600 vertical-center">{t('MESSAGING_COUNTER')}</p>
									<div className="col-md-4 p-0">
										<input
											type="number"
											min={0}
											className="form-control"
											{...register('messagingCounter', { valueAsNumber: true, min: 0 })}
											disabled={!isMessagingEnabled}
											onWheel={e => e.currentTarget.blur()}
										/>
									</div>
								</div>

							</div>
						</div>

						<div className="btn-wrapper">
							{getValues('id') ?
								<Link type="button" className="btn btn-warning btn-rounded btn-wide me-2" to="/pos">{t('CANCEL')}</Link>
								:
								<Link type="button" className="btn btn-warning btn-rounded btn-wide me-2" to="/admin/clients">{t('CANCEL')}</Link>
							}
							{cityId &&
								<button
									type="submit"
									className="btn btn-success btn-rounded btn-wide btn-wide"
									disabled={tariffCheck != null && !tariffCheck.sufficient}
									title={tariffCheck && !tariffCheck.sufficient ? t('INSUFFICIENT_BALANCE') : ''}
								>{t('SAVE')}</button>
							}
						</div>
					</form>
					<hr />
					<div className="mt-3">
						<button type="button" className="btn btn-outline-primary" onClick={openPaymentModal}>
							{t('PAYMENTS')}
						</button>
					</div>
					{payments.length > 0 && (
						<div className="mt-5">
							<h5 className="fw-600">{t('HISTORY')} ({t('PAYMENTS')})</h5>
							<table className="table table-bordered table-striped mt-3">
								<thead>
									<tr>
										<th>#</th>
										<th>{t('POS_FEE_TYPE')}</th>
										<th>{t('PAYMENT_DATE')}</th>
										<th>{t('AMOUNT')}</th>
										<th>{t('LAUNCH_DATE')}</th>
										<th>{t('STOP_DATE')}</th>
										<th>{t('ACTION')}</th>
									</tr>
								</thead>
								<tbody>
									{payments.map((payment, index) => {
										const fee = feeTypes.find(f => f.id === payment.posFeeId);
										return (
											<tr key={payment.id}>
												<td>{index + 1}</td>
												<td>{fee?.name || 'Unknown'}</td>
												<td>{payment.paymentDate}</td>
												<td>{payment.amount}</td>
												<td>{payment.startDate}</td>
												<td>{payment.endDate}</td>
												<td>
													<div className="table-action-button table-action-danger-button" onClick={() => deleteItem(payment.id)}>
														<i className="uil uil-trash-alt"></i>
													</div>
												</td>
											</tr>
										)
									})}
								</tbody>
							</table>
						</div>
					)}

					<Modal show={showPaymentModal} animation={false} centered dialogClassName="update-modal-width" backdrop="static" onHide={closePaymentModal}>
						<Modal.Header closeButton>
							<Modal.Title>{t('ADD')}</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<form onSubmit={handleSubmit(addPayment)}>
								<div className="form-group mb-2">
									<label>{t('POS_FEE_TYPE')}</label>
									<select className="form-control" name="feeId" {...register('feeId', { required: true })}>
										<option value="">{t('POS_FEE_TYPE')}</option>
										{feeTypes.map(f => (
											<option key={f.id} value={f.id}>{f.name}</option>
										))}
									</select>
									<span className="text-danger text-sm">{errors.feeId?.message}</span>
								</div>
								{/* Start Date */}
								<div className="form-group mb-2">
									<label>{t('PAID_FROM')}</label>
									<Controller
										name="startDate"
										control={control}
										rules={{ required: true }}
										render={({ field }) => (
											<DatePicker
												className="form-control"
												selected={field.value}
												onChange={field.onChange}
												dateFormat="dd.MM.yyyy"
												isClearable
											/>
										)}
									/>
									{errors.startDate && <span className="text-danger text-sm">Start Date is required</span>}
								</div>

								{/* End Date */}
								<div className="form-group mb-2">
									<label>{t('PAID_UNTIL')}</label>
									<Controller
										name="endDate"
										control={control}
										render={({ field }) => (
											<DatePicker
												className="form-control"
												selected={field.value}
												onChange={field.onChange}
												dateFormat="dd.MM.yyyy"
												isClearable
											/>
										)}
									/>
								</div>

								{/* Payment Date */}
								<div className="form-group mb-2">
									<label>{t('PAYMENT_DATE')}</label>
									<Controller
										name="paymentDate"
										control={control}
										rules={{ required: true }}
										render={({ field }) => (
											<DatePicker
												className="form-control"
												selected={field.value}
												onChange={field.onChange}
												dateFormat="dd.MM.yyyy"
											/>
										)}
									/>
									{errors.paymentDate && <span className="text-danger text-sm">Payment Date is required</span>}
								</div>
								<div className="form-group mb-4">
									<label>{t('AMOUNT')}</label>
									<input type="number" className="form-control" name="amount" {...register('amount', { required: true })} />
								</div>
								<div className="d-flex w-100">
									<button type="button" className="btn btn-outline-warning w-100 me-2" onClick={closePaymentModal}>{t('CANCEL')}</button>
									<button type="submit" className="btn btn-success w-100">{t('SAVE')}</button>
								</div>
							</form>
						</Modal.Body>
					</Modal>

				</div>
			</div>
		</>
	)
}

export default CreateUpdate

